// IMPORT ICONS

export const icons = {
  maths: "fas fa-calculator",
  chemistry: "fas fa-vial",
  physics: "fas fa-atom",
  geography: "fas fa-globe-americas",
  english: "fas fa-book",
  biology: "fas fa-tree",
  gym: "fas fa-dumbbell",
  cooking: "fas fa-cookie-bite",
  computer: "fas fa-laptop-code",
  bird: "fas fa-crow",
  spider: "fas fa-spider",
  biohazard: "fas fa-biohazard",
  car: "fas fa-car",
};
